
import { Box } from '@mui/material';

import { AccountMenu, ChatButton } from '@carcareers/components';
import { useAuth } from '@carcareers/hooks';
import { AuthRole } from '@libs/types';

export const ToolbarActions = () => {
  const { session } = useAuth();
  const role = session?.user?.role as AuthRole;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {role === AuthRole.EMPLOYER && <ChatButton />}
      <AccountMenu />
    </Box>
  );
};